import axios from 'axios'

let axiosConfig = {
  // baseURL: window.$baseUrl === undefined ? 'http://192.168.0.241:7777' : window.$baseUrl
  // baseURL: window.$baseUrl === undefined ? 'http://192.168.0.114:3000' : window.$baseUrl
  // baseURL: 'http://192.168.0.110:3005'
  // baseURL: 'http://192.168.0.110:3001'
  baseURL: 'http://www.xmhgapi.com/train'
  // baseURL: 'http://192.168.15.220:3005'
}
let server = axios.create(axiosConfig)

function getUrl () {
  return axiosConfig.baseURL
}

// 发送Post数据
function Post (type, msg) {
  // 要发送的数据
  let param = msg.data
  // 接收返回的回调函数
  let fn = msg.fn
  // 回调函数运行的this指针
  let vm = msg.vm

  let url = '/api/' + type

  let config = {
    params: param
  }

  server.post(url, config)
    .then((res) => {
      //  服务器响应数据在这里面
      // window.console.log('Post: ', res.data)
      let resdata = res.data
      if (fn === null || fn === undefined) {
        return
      }
      fn.call(vm, resdata)
    })
    .catch(() => {
      if (fn === null || fn === undefined) {
        return
      }
      fn.call(vm, null)
    })
}

// 发送Get数据
function Get (type, msg) {
  // 要发送的数据
  let param = msg.data
  // 接收返回的回调函数
  let fn = msg.fn
  // 回调函数运行的this指针
  let vm = msg.vm

  let config = {
    params: param
  }

  let url = '/api/' + type

  server.get(url, config)
    .then((res) => {
      // console.log('Get: ', res.data)
      // window.console.log('Get: ', res.data)
      if (fn === null || fn === undefined) {
        return
      }
      fn.call(vm, res.data)
    })
    .catch(() => {
      if (fn === null || fn === undefined) {
        return
      }
      fn.call(vm, null)
      // console.log('get: ', e)
    })
}

// 发送Put数据
function Put (type, msg) {
  // 要发送的数据
  let param = msg.data
  // 接收返回的回调函数
  let fn = msg.fn
  // 回调函数运行的this指针
  let vm = msg.vm

  let config = {
    params: param
  }

  let url = '/api/' + type

  server.put(url, config)
    .then((res) => {
      //  服务器响应数据在这里面
      let resdata = res.data
      if (fn === null || fn === undefined) {
        return
      }
      fn.call(vm, resdata)
    })
    .catch(() => {
      if (fn === null || fn === undefined) {
        return
      }
      fn.call(vm, null)
    })
}

// 发送Delete数据
function Delete (type, msg) {
  // 要发送的数据
  let param = msg.data
  // 接收返回的回调函数
  let fn = msg.fn
  // 回调函数运行的this指针
  let vm = msg.vm

  let config = {
    data: {
      params: param
    }
  }
  let url = '/api/' + type

  server.delete(url, config)
    .then((res) => {
      //  服务器响应数据在这里面
      let resdata = res.data
      if (fn === null || fn === undefined) {
        return
      }
      fn.call(vm, resdata)
    })
    .catch(() => {
      if (fn === null || fn === undefined) {
        return
      }
      fn.call(vm, null)
    })
}

export {
  server,
  Get,
  Post,
  Put,
  Delete,
  getUrl
}



// WEBPACK FOOTER //
// ./src/utils/requestBOOK.js